import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IBaseProps } from '@rbi-ctg/frontend';

import { AllergenGroup } from './types';
import { allergenIncludesToIntlId } from './utils';

const AllergensContainer = styled.div`
  margin-block-start: 3px;
  font-size: 0.7rem;
  font-weight: ${Styles.fontWeight.heavy};

  p + p {
    margin-block-start: 3px;
  }
`;

const AllergensText = styled.p<{ color?: string }>`
  margin: 0;
  font-weight: ${Styles.fontWeight.heavy};
`;

const AllergenNames = styled.span<{ textTransform?: string }>`
  font-weight: ${Styles.fontWeight.normal};
  text-transform: ${p => p.textTransform || 'inherit'};
`;

export interface IAllergensProps extends IBaseProps {
  allergenGroups: AllergenGroup[];
}

export const Allergens: React.FC<IAllergensProps> = ({ allergenGroups, className }) => {
  const { formatMessage } = useIntl();
  if (!allergenGroups.length) {
    return null;
  }

  return (
    <AllergensContainer className={className}>
      {allergenGroups.map(group => {
        const id = allergenIncludesToIntlId(group.allergenIncludes);
        if (!id) {
          return null;
        }
        const allNames = group.allergenNames.join(', ');
        return (
          <AllergensText key={id}>
            {formatMessage(
              { id },
              {
                allergens: (
                  <>
                    <AllergenNames textTransform="capitalize">{allNames}</AllergenNames>
                    <br />
                  </>
                ),
              }
            )}
          </AllergensText>
        );
      })}
    </AllergensContainer>
  );
};
